import { SgaLogo } from './SgaLogo';

/**
 * Logo exibida com a sidebar recolhida.
 *
 * A marca da SGA é só um wordmark — não existe símbolo quadrado separado, nem
 * no site nem no favicon deles. Por isso aqui é a mesma logo, reduzida para
 * caber na faixa estreita (~48px úteis) em vez de um ícone próprio.
 */
export const LogoIcon = () => <SgaLogo height={14} />;
